import { IsEnabledOnGridWithSettingsBaseValueConverter } from 'General/Resources/ValueConverters/IsEnabledOnGridWithSettingsBase';

export class IsEnabledOnGridWithSettingsValueConverter extends IsEnabledOnGridWithSettingsBaseValueConverter {

}